module.exports = __webpack_public_path__ + "img/logo_small.07783645.png";